//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CategoryCheckboxFilter from '~/components/organisms/Category/CategoryCheckboxFilter.vue';
import CategoryDimensionsFilter from '~/components/organisms/Category/CategoryDimensionsFilter.vue';
import Accordion from '~/components/molecules/Accordion.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cross.svg';

const CategoryRangeFilter = () => import('~/components/organisms/Category/CategoryRangeFilter.vue');

export default {
  name: 'CategoryFiltersList',
  components: {
    CategoryCheckboxFilter,
    CategoryDimensionsFilter,
    CategoryRangeFilter,
    Accordion
  },
  props: {
    activeFilters: {
      type: Array,
      required: true
    },
    filters: {
      type: Array,
      required: true
    },
    desktopLayer: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedFilter: null
    };
  },

  computed: {
    validFilters() {
      return this.filters && this.filters.length > 0 ? this.filters.filter(f => f.facets) : [];
    }

  },
  methods: {
    getFilterActiveFacetsLabel(filter) {
      let filterActivefacets = null;

      if (filter.name === 'price.amount') {
        const priceFacet = this.activeFilters.find(f => f.filter === 'price' && f.label);
        return priceFacet ? priceFacet.label : '';
      }

      if (filter.name === 'dimensions') {
        const dimensionFilters = ['width', 'height', 'depth'];
        filterActivefacets = this.activeFilters.filter(f => dimensionFilters.includes(f.filter));
        filterActivefacets = filterActivefacets.map(e => "".concat(this.$t(e.filter), ": ").concat(e.label));
        return filterActivefacets ? filterActivefacets.map(e => e.trim()).join(', ') : '';
      }

      filterActivefacets = this.activeFilters.filter(f => f.filter === filter.name && f.label && f.label.trim());
      return filterActivefacets ? filterActivefacets.map(e => e.label.trim()).join(', ') : '';
    }

  }
};